import { tns } from 'tiny-slider/src/tiny-slider'

export default class TextSlider {
  static init () {
    if (document.querySelector('.vol_slides') === null) {
      return
    }

    this.slides = tns({
      container: '.vol_slides',
      items: 1,
      slideBy: 'page',
      rewind: true,
      navPosition: 'bottom',
      controlsPosition: 'bottom',
    })

    requestAnimationFrame(() => {
      const width = document.querySelector('.tns-nav').offsetWidth

      document.querySelector('.vol_slider_controls').style.width = `${width + 50 + 60}px`
    })

    document.querySelector('.vol_slider_controls .prev').addEventListener('click', () => {
      document.querySelector('[data-controls="prev"]').click()
    })

    document.querySelector('.vol_slider_controls .next').addEventListener('click', () => {
      document.querySelector('[data-controls="next"]').click()
    })
  }
}
